import { billing } from '@/store/admin/billing.module';
import { invites } from '@/store/admin/invites.module';
import { tenantModules } from '@/store/admin/tenant-modules.module';
import { tenantPlatforms } from '@/store/admin/tenant-platforms.module';
import { tenant } from '@/store/admin/tenant.module';
import { tenants } from '@/store/admin/tenants.module';
import { annotations } from '@/store/annotations.module';
import { appVersionDetector } from '@/store/app-version-detector.module';
import { auth } from '@/store/auth.module';
import { contactDirectory } from '@/store/contact-directory.module';
import { biDashboard } from '@/store/bi-dashboard.module';
import { changePassword } from '@/store/change-password.module';
import { currentDocument } from '@/store/current-document.module';
import { documentKeywords } from '@/store/document-keywords.module';
import { extractionOutputFileTemplates } from '@/store/estimation/extraction-output-file-templates.module';
import { productBundleExtractionOutputFiles } from '@/store/estimation/product-bundle-extraction-output-files.module';
import { productBundleExtraction } from '@/store/estimation/product-bundle-extraction.module';
import { productBundleExtractions } from '@/store/estimation/product-bundle-extractions.module';
import { productBundleTemplates } from '@/store/estimation/product-bundle-templates.module';
import { evaluationGrid } from '@/store/evaluation-grid.module';
import { exploreSearchFilters } from '@/store/explore-search-filters.module';
import { contactDirectorySearchFilters } from '@/store/contact-directory-search-filters.module';
import { goNoGo } from '@/store/go-nogo.module';
import { unassignedPotentialBidders } from '@/store/unassigned-potential-bidders.module';
import { keywords } from '@/store/keywords.module';
import { modes } from '@/store/modes.module';
import { opportunities } from '@/store/opportunities.module';
import { opportunityDocuments } from '@/store/opportunity-documents.module';
import { opportunityKeywordSearch } from '@/store/opportunity-keyword-search.module';
import { opportunitySyncProfiles } from '@/store/opportunity-sync-profiles.module';
import { opportunitySyncProfile } from '@/store/opportunity-sync-profile.module';
import { opportunitySyncProfileContacts } from '@/store/opportunity-sync-profile-contacts.module';
import { opportunitySyncProfileAccounts } from '@/store/opportunity-sync-profile-accounts.module';
import { opportunitySync } from '@/store/opportunity-sync.module';
import { opportunity } from '@/store/opportunity.module';
import { tenderOpportunities } from '@/store/tender-opportunities.module';
import { tenderViews } from '@/store/tender-views.module';
import { pdfData } from '@/store/pdf-data.module';
import { platforms } from '@/store/platforms.module';
import { searchFilters } from '@/store/search-filters.module';
import { taskCitations } from '@/store/task-citations.module';
import { taskStatuses } from '@/store/task-statuses.module';
import { tasks } from '@/store/tasks.module';
import { tender } from '@/store/tender.module';
import { tenders } from '@/store/tenders.module';
import { acceptInvite } from '@/store/usecase/accept-invite.usecase';
import { confirmEmail } from '@/store/usecase/confirm-email.usecase';
import { exportTenders } from '@/store/usecase/export-tenders.usecase';
import { sendEmailConfirmation } from '@/store/usecase/send-email-confirmation.usecase';
import { validateInvite } from '@/store/usecase/validate-invite.usecase';
import { userPlatforms } from '@/store/user-platforms.module';
import { userPreferences } from '@/store/user-preferences.module';
import { userProfile } from '@/store/user-profile.module';
import { users } from '@/store/users.module';
import Vue from 'vue';
import Vuex from 'vuex';
import { opportunityLabels } from '@/store/opportunity-labels.module';
import { opportunityStatuses } from '@/store/opportunity-statuses.module';
import { potentialBidders } from '@/store/potential-bidders.module';
import { preProjects } from '@/store/pre-projects.module';
import { preProjectViews } from '@/store/pre-project-views.module';
import { quotes } from '@/store/quotes.module';
import { quoteSync } from '@/store/quote-sync.module';
import { tenantLocations } from '@/store/admin/tenant-locations.module';
import { opportunityMobilizations } from '@/store/opportunity-mobilizations.module';
import { opportunityJobLocation } from '@/store/opportunity-job-location.module';
import { evaluationGridTemplates } from './evaluation-grid-templates.module';
import { evaluationGridTemplateFields } from '@/store/evaluation-grid-template-fields.module';
import { opportunityDocumentsQueue } from '@/store/opportunity-documents-queue.module';
import { opportunityDocumentsPdfEngine } from '@/store/opportunity-documents-pdf-engine.module';
import { chromeExtension } from '@/store/chrome-extension.module';
import { syncFieldMappings } from '@/store/sync-field-mappings.module';
import { adminSyncProfiles } from '@/store/admin/sync-profiles.module';
import { adminSyncProfileFieldMappings } from '@/store/admin/sync-profile-field-mappings.module';
import { valueExpressionSchema } from '@/store/admin/value-expression-schema.module';
import { userNotificationSettings } from '@/store/user-notification-settings.module';
import { notificationTypes } from '@/store/notification-types.module';
import { classifications } from '@/store/classifications.module';
import { biTenant } from '@/store/bi-tenant.module';
import { taskTemplates } from '@/store/task-templates.module';
import { extractionJob } from '@/store/extraction-job/extraction-job.module';
import { fieldsExtraction } from '@/store/extraction-job/fields-extraction.module';
import { requirementsExtraction } from '@/store/extraction-job/requirements-extraction.module';
import { tenantOpportunitySettings } from '@/store/tenant-opportunity-settings.module';
import { terminology } from '@/store/terminology.module';
import { adminTerminology } from '@/store/admin/terminology.module';
import { notifications } from './notifications.module';
import { tenantProfile } from '@/store/tenant-profile.module';
import { formFill } from '@/store/form-fill.module';
import { notificationStatuses } from './notification.statuses.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    acceptInvite,
    annotations,
    appVersionDetector,
    auth,
    biDashboard,
    biTenant,
    billing,
    changePassword,
    chromeExtension,
    classifications,
    confirmEmail,
    contactDirectory,
    contactDirectorySearchFilters,
    currentDocument,
    documentKeywords,
    evaluationGrid,
    evaluationGridTemplates,
    evaluationGridTemplateFields,
    exploreSearchFilters,
    exportTenders,
    extractionOutputFileTemplates,
    goNoGo,
    invites,
    keywords,
    modes,
    notifications,
    notificationStatuses,
    notificationTypes,
    opportunities,
    opportunity,
    opportunityDocuments,
    opportunityDocumentsPdfEngine,
    opportunityDocumentsQueue,
    opportunityJobLocation,
    opportunityKeywordSearch,
    opportunityLabels,
    opportunityMobilizations,
    opportunityStatuses,
    opportunitySync,
    opportunitySyncProfile,
    opportunitySyncProfileAccounts,
    opportunitySyncProfileContacts,
    opportunitySyncProfiles,
    pdfData,
    platforms,
    potentialBidders,
    preProjects,
    preProjectViews,
    productBundleExtraction,
    productBundleExtractionOutputFiles,
    productBundleExtractions,
    productBundleTemplates,
    quoteSync,
    quotes,
    searchFilters,
    sendEmailConfirmation,
    syncFieldMappings,
    adminSyncProfiles,
    adminSyncProfileFieldMappings,
    valueExpressionSchema,
    extractionJob,
    fieldsExtraction,
    requirementsExtraction,
    tenant,
    tenantProfile,
    formFill,
    tenantLocations,
    tenantModules,
    tenantPlatforms,
    tenants,
    taskCitations,
    taskStatuses,
    tasks,
    taskTemplates,
    tender,
    tenders,
    unassignedPotentialBidders,
    userNotificationSettings,
    userPlatforms,
    userPreferences,
    userProfile,
    users,
    validateInvite,
    tenderOpportunities,
    tenderViews,
    tenantOpportunitySettings,
    terminology,
    adminTerminology,
  },
});
